<template>
  <div class="dorm-wrapper">
    <div v-if="isShowFormMobile" class="fixed_mobile_overlay"></div>
    <RoomMobileForm
      :show="showMobileBottom"
      :show-form="isShowFormMobile"
      :show-success-message="showSuccessMessage"
      :room="room"
      :call-phone="phone"
      :dates="dates"
      @toggle="toggleMobileForm"
      @send-whatsapp="sendWhatsappMessage"
    ></RoomMobileForm>

    <Modal2 :active="showVirtualTour" @onModalClose="closeModalVirtualTour">
      <div slot="content">
        <iframe
          width="1024"
          height="768"
          class="ql-video"
          frameborder="0"
          allowfullscreen="true"
          :src="virtual_tour"
        ></iframe
        >'
      </div>
    </Modal2>
    <Modal2 :active="showModal" @onModalClose="closeModal">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <span class="close" ref="close" v-on:click="closeModal">&times;</span>
          <h3 class="login-box__title">ÜYE GİRİŞİ</h3>
          <v-input
            ref="input1"
            placeholder="E-mail adresiniz"
            v-model="loginForm.email"
          />
          <label
            for="password"
            v-if="falseEmail2"
            class="myValidationText"
            required
            >Geçersiz e-posta formatı!</label
          >
          <label for="password" v-if="emptyEmail2" class="myValidationText"
            >Bu kısım boş geçilemez!</label
          >
          <span class="text-danger"></span>
          <v-input
            ref="input2"
            placeholder="Şifreniz"
            type="password"
            v-model="loginForm.password"
          />
          <label for="password" v-if="emptyPassword" class="myValidationText"
            >Bu kısım boş geçilemez!</label
          >
          <router-link class="password-forget" to="/sifremi-unuttum">
            Şifremi Unuttum</router-link
          >
          {{ error }}
          <v-button
            class="green fw shadow-none login-box__submit"
            @click.native="login"
            title="GİRİŞ YAP"
          />
          <div class="or">
            <p>
              <span class="mycolorBlue">Yurtlarburada</span
              ><span class="mycolor2">.com</span>'da yeni misiniz?
            </p>
          </div>
          <v-button
            class="gray fw shadow-none login-box__submit"
            @click.native="register"
            title="KAYIT OL"
          />
        </div>
      </div>
    </Modal2>
    <Modal2 :active="showSuccessMessage" @onModalClose="closeSuccessMessage">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <span class="close" ref="close" v-on:click="closeSuccessMessage"
            >&times;</span
          >
          <div class="clear"></div>
          <h2 class="login-box__title">MESAJINIZ GÖNDERİLDİ!</h2>
          <div class="or">
            <p>
              <span class="mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span>
            </p>
            <p>
              <span class="mycolorBlue"
                >Arkadaşlarımız en yakın zamanda sizinle iletişime
                geçecek.</span
              >
            </p>
          </div>
        </div>
      </div>
    </Modal2>
    <div class="dorm__inner">
      <div class="dorm-top__wrp" ref="dormContent">
        <div>&nbsp;</div>
        <container>
          <div class="dorm-top">
            <div class="dorm-top__content">
              <div class="dorm-header">
                <div slot="bread">
                  <ol itemscope itemtype="https://schema.org/BreadcrumbList">
                    <li
                      class="mytitle1 myli"
                      itemprop="itemListElement"
                      itemscope
                      itemtype="http://schema.org/ListItem"
                    >
                      <a
                        href="https://yurtlarburada.com/"
                        class=""
                        itemtype="https://schema.org/Thing"
                        itemprop="item"
                      >
                        <span itemprop="name">yurtlarburada.com</span>
                        <span>&nbsp;/&nbsp;</span>
                      </a>
                      <meta itemprop="position" content="1" />
                    </li>

                    <li
                      class="color-white mytitle1 myli"
                      itemprop="itemListElement"
                      itemscope
                      itemtype="http://schema.org/ListItem"
                    >
                      <a
                        :href="city_url"
                        class=""
                        itemtype="https://schema.org/Thing"
                        itemprop="item"
                      >
                        &nbsp;<span itemprop="name"
                          >{{ getCity.name }} Öğrenci Yurtları</span
                        >
                      </a>
                      <meta itemprop="position" content="2" />
                    </li>

                    <li
                      class="color-white mytitle1 myli"
                      itemprop="itemListElement"
                      itemscope
                      itemtype="http://schema.org/ListItem"
                    >
                      <a
                        :href="district_url"
                        class=""
                        itemtype="https://schema.org/Thing"
                        itemprop="item"
                      >
                        &nbsp;<span class="mysize">&nbsp;/&nbsp;</span>
                        &nbsp;<span itemprop="name"
                          >{{ getDistrict.name }} Öğrenci Yurtları</span
                        >
                      </a>
                      <meta itemprop="position" content="3" />
                    </li>
                    <li
                      class="color-white mytitle1 myli"
                      itemprop="itemListElement"
                      itemscope
                      itemtype="http://schema.org/ListItem"
                    >
                      <a
                        :href="dorm_url"
                        class=""
                        itemtype="https://schema.org/Thing"
                        itemprop="item"
                      >
                        &nbsp;<span class="mysize">&nbsp;/&nbsp;</span>
                        &nbsp;<span itemprop="name">{{ dorm_title }}</span>
                      </a>
                    </li>
                  </ol>
                </div>
                <div class="dorm-header__top" v-if="detail">
                  <div class="dorm-header-logo" v-if="detail.dorm.logo">
                    <img
                      :src="detail.dorm.logo"
                      alt=""
                      class="dorm-header-logo__img"
                    />
                  </div>

                  <div class="dorm-header__content" v-if="detail">
                    <div class="dorm-header__title">{{ name }}</div>
                    <div class="dorm-header-loc">
                      <span class="dorm-header-loc__icon">
                        <svg-icon type="icon-location" />
                      </span>
                      <div class="dorm-header-loc__title">
                        {{ detail.dorm.district.name }},
                        {{ detail.dorm.city.name }}
                      </div>
                    </div>
                  </div>
                  <div class="dorm-header-price" v-if="room">
                    <div class="dorm-header-price__title">
                      {{ room.daily_price }} TL
                    </div>
                    <span class="dorm-header-price__txt">
                      'den başlayan fiyatlarla
                    </span>
                  </div>

                  <div class="right-mobile" style="display: none">
                    <div class="dorm-form-buttons">
                      <button
                        v-on:click="setFavorite()"
                        class="button dorm-form-buttons__item circle round"
                        :class="[
                          {
                            'white blue': !isFavorite,
                            'red addedFavorite': isFavorite
                          }
                        ]"
                      >
                        <span class="button__wrp"
                          ><span class="button__icon"
                            ><svg class="icon">
                              <use
                                xlink:href="/icon/icons.svg#icon-heart"
                              ></use></svg></span
                        ></span>
                      </button>
                      <button
                        v-on:click="showShare()"
                        class="button dorm-form-buttons__item circle round"
                        :class="[
                          {
                            'white blue': !isShare,
                            'green white sharedOn': isShare
                          }
                        ]"
                      >
                        <span class="button__wrp"
                          ><span class="button__icon"
                            ><svg class="icon">
                              <use
                                xlink:href="/icon/icons.svg#icon-share"
                              ></use></svg></span
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
                <ContentLoader v-if="!detail" :height="700" :width="500">
                  <rect x="2" y="20" rx="3" ry="3" width="80" height="40" />
                  <rect x="2" y="70" rx="3" ry="3" width="500" height="320" />
                  <rect x="2" y="400" rx="3" ry="3" width="75" height="60" />
                  <rect x="85" y="400" rx="3" ry="3" width="75" height="60" />
                  <rect x="170" y="400" rx="3" ry="3" width="75" height="60" />
                  <rect x="255" y="400" rx="3" ry="3" width="75" height="60" />
                  <rect x="340" y="400" rx="3" ry="3" width="75" height="60" />
                  <rect x="425" y="400" rx="3" ry="3" width="75" height="60" />
                </ContentLoader>
                <div class="dorm-gallery">
                  <div class="gallery" v-if="detail">
                    <GalleryThumb
                      :gallery="images"
                      :hasVideo="hasVideo"
                      v-if="images.length > 0"
                    />
                    <div
                      class="dorm-gallery-empty"
                      v-if="
                        !detail.dorm.images || detail.dorm.images.length === 0
                      "
                    >
                      <img
                        src="@/assets/img/yurtlarburada-default.jpg"
                        alt=""
                        class="dorm-gallery-empty__img"
                      />
                    </div>
                  </div>
                </div>
                <social-sharing
                  v-if="showShareButtons"
                  :url="this.url"
                  :title="this.name"
                  :description="this.description"
                  :quote="this.name"
                  hashtags="yurtlarburada"
                  :twitter-user="this.twitter_user"
                  inline-template
                >
                  <div class="dorm-form__wrp mysharebuttons ">
                    <div class="icon-font">
                      <network network="facebook">
                        <span class="icon-font mybutton">
                          <svg-icon type="icon-facebook" />
                        </span>
                      </network>
                      <network network="twitter">
                        <span class="icon-font mybutton">
                          <svg-icon type="icon-twitter" />
                        </span>
                      </network>
                      <network network="whatsapp">
                        <span class="icon-font mybutton ">
                          <svg-icon type="icon-whatsapp" />
                        </span>
                      </network>

                      <network network="email">
                        <span class="icon-font mybutton">
                          <svg-icon type="icon-mail" />
                        </span>
                      </network>
                    </div>
                  </div>
                </social-sharing>
                <div class="dorm-header__bottom">
                  <div class="dorm-header-inf" v-if="detail">
                    <div
                      class="dorm-header-inf__item"
                      v-if="detail.dorm.capacity"
                    >
                      <span class="dorm-header-inf__icon">
                        <svg-icon type="icon-bed" />
                      </span>
                      <div class="dorm-header-inf__txt">
                        {{ detail.dorm.capacity }}
                        <i class="spc-text myfontstyle">Yatak</i>
                      </div>
                    </div>

                    <div class="dorm-header-inf__item" v-if="detail.dorm.meal">
                      <span class="dorm-header-inf__icon">
                        <svg-icon type="icon-food" />
                      </span>
                      <div class="dorm-header-inf__txt">
                        {{ detail.dorm.meal }}
                        <i class="spc-text myfontstyle">Öğün</i>
                      </div>
                    </div>

                    <div
                      class="dorm-header-inf__item"
                      v-if="detail.dorm.is_wifi"
                    >
                      <span class="dorm-header-inf__icon">
                        <svg-icon type="icon-wifi" />
                      </span>
                      <div class="dorm-header-inf__txt">
                        <i class="spc-text myfontstyle">Wi-Fi</i> Var
                      </div>
                    </div>
                  </div>

                  <div class="dorm-header-customer">
                    <div class="dorm-header-customer__cnt">
                      <div
                        class="dorm-header-customer__name"
                        v-if="member && member != 'null'"
                      >
                        {{ member }}
                      </div>
                      <div
                        class="dorm-header-customer__branch"
                        v-if="member && member != 'null'"
                      >
                        Yetkili Danışman
                      </div>
                    </div>
                    <span
                      class="dorm-header-customer__icon"
                      v-if="member && member != 'null'"
                    >
                      <svg-icon type="icon-headphone" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="dorm-top__cnt" v-if="detail">
                <div class="dorm-top-address">
                  <span class="dorm-top-address__icon">
                    <svg-icon type="icon-location" />
                  </span>
                  <div class="dorm-top-address__title">
                    {{ detail.dorm.address }}
                  </div>
                </div>
                <div class="dorm-top-address">
                  <!-- <a target="_blank" v-if="detail.dorm.web" :href="'http://' + detail.dorm.web">   -->
                  <span class="dorm-top-address__icon" v-if="detail.dorm.web">
                    <svg-icon type="icon-web" />
                  </span>
                  <span class="dorm-top-address__title"
                    >{{ detail.dorm.web }}
                    <b v-if="detail.dorm.web"
                      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b
                    ></span
                  >
                  <!-- </a> -->

                  <a
                    v-if="detail.dorm.phone"
                    :href="'tel:' + detail.dorm.phone"
                  >
                    <span class="dorm-top-address__icon">
                      <svg-icon type="icon-phone1" />
                    </span>

                    <span class="dorm-top-address__title">{{
                      detail.dorm.phone
                    }}</span>
                  </a>
                </div>
                <div class="myborder"></div>
                <p>&nbsp;</p>
                <div
                  class="dorm-content-collapse"
                  :style="{
                    height: collapseContent ? collapseContentHeight : '200px'
                  }"
                >
                  <div
                    class="dorm-top__txt"
                    ref="dormContentText"
                    v-html="detail.dorm.content"
                  ></div>
                </div>
                <div
                  class="lengthDots"
                  v-if="
                    detail.dorm.content &&
                      detail.dorm.content.length >= 450 &&
                      !collapseContent
                  "
                >
                  ...
                </div>
                <v-button
                  v-if="
                    detail.dorm.content && detail.dorm.content.length >= 450
                  "
                  class="button--more dorm-top__button"
                  @click.native="toggleContentText"
                  :title="collapseContent ? 'Daha az gör' : 'Devamını Oku'"
                  :icon="
                    collapseContent ? 'icon-arrow-up' : 'icon-arrow-long-right'
                  "
                  icon-position="right"
                />
              </div>
            </div>
            <div class="dorm-top__left" ref="dormRight">
              <RoomForm
                v-if="showDormForm"
                :fixed-form="fixedForm"
                :form-offset="formOffset"
                :form-width="formWidth"
                :room="room"
                :current-price="currentPrice"
                :dormId="id"
                :phone1="phone"
                :dates="dates"
                :phoneForMessage="phoneForMessage"
                :name="name"
                :description="description"
                :city_name="city_name"
                :district_name="district_name"
                :keywords="keywords"
                :dorm_slug="dorm_slug"
                ref="dormForm"
              />
            </div>
          </div>
        </container>
      </div>

      <div class="dorm__content">
        <div :class="{ stickyTab: stickyTab }" class="sticky-nav">
          <container>
            <div class="sticky-nav__list">
              <div
                class="sticky-nav__item"
                v-for="(tab, index) in tabsMenu"
                :key="tab.id"
                :class="{ active: tab.isActive }"
              >
                <v-button
                  class="sticky-nav__link"
                  :title="tab.title"
                  :class="{ active: tab.isActive }"
                  @click.native="tabSelect(index, tab.title)"
                />
              </div>
            </div>
          </container>
        </div>
      </div>
      <div class="sticky-nav__space"></div>
      <!--<div id="one" ref="paneOne">-->
      <!--<div class="mobile-gen-title"><p>Odalar</p></div>-->
      <!--<container>-->

      <!--<div class="dorm-room">-->
      <!--<dorm-accordion-item-->
      <!--v-for="room in rooms" :key="room.id"-->
      <!--:item="room"-->
      <!--@onPriceChange="changePrice"-->
      <!--/>-->
      <!--</div>-->
      <!--</container>-->
      <!--</div>-->
      <div id="one" class="property-wrp" ref="paneOne">
        <div class="mobile-gen-title">
          <p>Hizmet ve Özellikler</p>
        </div>

        <container>
          <div class="dorm-tabs col-xs-12 col-md-12 pad0-i">
            <div class="dorm-tabs col-xs-12 col-md-8 pad0-i" v-if="detail">
              <div v-for="property in properties" :key="property.id">
                <dorm-property :dataServices="property" />
              </div>
            </div>
          </div>
        </container>
      </div>

      <div id="room-availability" class="dorm-comment-wrapper">
        <container>
          <div class="col-xs-12 col-md-8">
            <div class="section__header">
              <div class="section__title">
                <span class="color-light-green">Uygunluk</span> Takvimi
              </div>
            </div>
            <div>
              <p>&nbsp;</p>
            </div>
            <RoomAvailabilityCalendar
              :availability="availability"
              @update:dates="dates = $event"
            ></RoomAvailabilityCalendar>
          </div>
        </container>
      </div>

      <div id="two" class="dorm-comment-wrapper" ref="paneTwo">
        <div class="mobile-gen-title">
          <p>Yorumlar</p>
        </div>
        <container>
          <div class="comment col-xs-12 col-md-8">
            <div>
              <p>&nbsp;</p>
            </div>

            <div class="result-bracket__title">
              <div v-if="comments.length !== 0">
                <span class="result-bracket__count" v-if="comments.length !== 0"
                  >{{ comments.length }}
                </span>
                Yorum Bulundu !
              </div>
              <EmptyComment
                :content="emptyContent"
                v-if="comments.length === 0"
              />
            </div>
            <div
              class="dorm-comment__item"
              v-for="comment in comments"
              :key="comment.id"
            >
              <div class="dorm-comment__item-gen">
                <!-- <img :src="comment.image" class="dorm-comment__img" alt=""> -->
                <avatar
                  :fullname="
                    comment.user.first_name + ' ' + comment.user.last_name
                  "
                  size="36"
                  color="#4b5ba4"
                ></avatar>
                <div class="dorm-comment__content">
                  <h3 class="dorm-comment__name">
                    {{ comment.user.first_name }} {{ comment.user.last_name }}
                  </h3>
                  <span class="dorm-comment__date">{{
                    comment.created_at
                  }}</span>
                  <p class="dorm-comment__text">
                    {{ comment.comment }}
                  </p>
                  <!--                 <div class="dorm-comment__reply">
  <span class="dorm-comment__ico">
  <svg-icon type="icon-enter"/>
  </span>
                    <p class="dorm-comment__reply-text" @click="answer(comment.user.first_name + ' ' + comment.user.last_name)">Cevapla</p>
                  </div> -->
                </div>
              </div>

              <div
                class="dorm-comment__item--replies"
                v-for="reply in comment.replies"
                :key="reply.id"
              >
                <img :src="reply.image" class="dorm-comment__img" alt="" />
                <div class="dorm-comment__content">
                  <h3 class="dorm-comment__name">
                    {{ reply.user.first_name }}
                  </h3>
                  <span class="dorm-comment__date">{{ reply.created_at }}</span>
                  <p class="dorm-comment__text">
                    {{ reply.comment }}
                  </p>
                  <div class="dorm-comment__reply">
                    <span class="dorm-comment__ico">
                      <svg-icon type="icon-enter" />
                    </span>
                    <p class="dorm-comment__reply-text">Cevapla</p>
                  </div>
                </div>
              </div>
            </div>
            <form>
              <div class="comment__reply-text">
                <input
                  ref="messageField"
                  type="text"
                  placeholder="İlk Yorumu Sen Yap!"
                  class="comment__entry"
                  v-model="this.answerName"
                  v-if="comments.length === 0 && !isEmptyComment"
                  required
                />
                <input
                  ref="messageField"
                  type="text"
                  placeholder="Yorumunuzu buraya yazınız.."
                  class="comment__entry"
                  v-model="this.answerName"
                  v-if="comments.length !== 0 && !isEmptyComment"
                  required
                />
                <input
                  ref="messageField"
                  type="text"
                  placeholder="Lütfen Boş Bırakmayınız!"
                  class="comment__entry mycolor2"
                  v-model="this.answerName"
                  v-if="isEmptyComment"
                  required
                />
                <span
                  v-on:click="sendComment()"
                  class="comment__reply-text--ico"
                >
                  <svg-icon type="icon-send" />
                </span>
              </div>
            </form>
          </div>
        </container>
        <div>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
      <div id="three" ref="paneThree">
        <div class="dorm-map" v-if="showMap">
          <div class="mobile-gen-title">
            <p>Harita</p>
          </div>
          <gmap-map
            :options="mapOptions"
            :center="center"
            :zoom="15"
            style="width: 100%; height: 500px"
            ref="mapRef"
          >
            <gmap-info-window
              :options="infoOptions"
              :position="marker.position"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <div class="map-info" v-if="detail">
                <span class="map-info__icon">
                  <img
                    src="@/assets/img/icon-male.svg"
                    alt=""
                    class="icon"
                    v-if="detail.dorm.dorm_type_id == 1"
                  />
                  <img
                    src="@/assets/img/icon-female.svg"
                    alt=""
                    class="icon"
                    v-if="detail.dorm.dorm_type_id == 2"
                  />
                </span>
                <div class="map-info__content">
                  <div
                    class="map-info__name"
                    v-if="detail.dorm.dorm_type_id == 2"
                  >
                    {{ detail.dorm.name }}
                  </div>
                  <div
                    class="map-info__nameBoys"
                    v-if="detail.dorm.dorm_type_id == 1"
                  >
                    {{ detail.dorm.name }}
                  </div>
                  <div class="map-info__address">
                    {{ detail.dorm.address }}
                  </div>
                </div>
                <button class="button map-info__button">
                  <span class="button__wrp">
                    <a :href="mapurl" target="_blank">
                      <span class="button__icon">
                        <img
                          src="@/assets/img/get-directions.svg"
                          alt=""
                          class="icon"
                        /> </span
                    ></a>
                    <a :href="mapurl" target="_blank">
                      <span class="button__txt">
                        Yol Tarifi Al
                      </span></a
                    >
                  </span>
                </button>
              </div>
            </gmap-info-window>

            <gmap-marker
              :icon="require('@/assets/img/marker.png')"
              :position="marker.position"
              :clickable="true"
              @click="toggleInfoWindow()"
              v-if="detail.dorm.dorm_type_id == 2"
            ></gmap-marker>
            <gmap-marker
              :icon="require('@/assets/img/marker-male.png')"
              :position="marker.position"
              :clickable="true"
              @click="toggleInfoWindow()"
              v-if="detail.dorm.dorm_type_id == 1"
            ></gmap-marker>
          </gmap-map>
        </div>
      </div>

      <div
        v-if="detail && branches.length > 0"
        class="city-uni dorm-slider"
        ref="dormSlider"
      >
        <container>
          <div class="city-uni__wrp">
            <div class="section__header">
              <div class="section__title">
                <span class="color-light-green">Diğer</span> Şubeler
              </div>
              <div class="section__right">
                <v-button
                  icon="icon-arrow-left"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-prev"
                />

                <v-button
                  icon="icon-arrow-right"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-next"
                />
              </div>
            </div>
            <swiper
              class="city-uni-slider"
              v-if="detail"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="dorm in branches"
                :key="dorm.id"
                class="city-uni-slider__item"
              >
                <dorm-card :dorm="dorm" />
              </swiper-slide>
            </swiper>
          </div>
        </container>
      </div>

      <div class="city-uni dorm-slider" ref="dormSlider">
        <container>
          <div class="city-uni__wrp">
            <div class="section__header">
              <div class="section__title">
                <span class="color-light-green">Benzer</span> Yurtlar
              </div>
              <div class="section__right">
                <v-button
                  icon="icon-arrow-left"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-prev"
                />

                <v-button
                  icon="icon-arrow-right"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-next"
                />
              </div>
            </div>
            <swiper
              class="city-uni-slider"
              v-if="detail"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="dorm in detail.similarDorms"
                :key="dorm.id"
                class="city-uni-slider__item"
              >
                <dorm-card :dorm="dorm" />
              </swiper-slide>
            </swiper>
          </div>
        </container>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import DormCard from '@/components/DormCard'
import DormProperty from '@/components/DormProperty'
import EmptyComment from '@/components/EmptyComment'
import GalleryThumb from '@/components/GalleryThumb'
import Modal2 from '@/components/Modal2'
import RoomForm from '@/components/Room/RoomForm'
import VueInputRestricted from '@/components/VueInputRestricted'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity'
import RoomAvailabilityCalendar from '@/features/Room/RoomAvailabilityCalendar'
import { SET_USER_INFO } from '@/store/mutations.type'
import axios from 'axios'
import Avatar from 'vue-avatar-component'
import { ContentLoader } from 'vue-content-loader'
import SocialSharing from 'vue-social-sharing'
import { mapGetters } from 'vuex'
import RoomMobileForm from '../../components/Room/RoomMobileForm.vue'
// import Loading from 'vue-loading-overlay'
export default {
  name: 'DormDetail',
  components: {
    GalleryThumb,
    DormCard,
    DormProperty,
    RoomForm,
    Avatar,
    Modal2,
    EmptyComment,
    SocialSharing,
    VueInputRestricted,
    VueSelectTempUniversity,
    VueSelectTempFaculty,
    ContentLoader,
    RoomAvailabilityCalendar,
    RoomMobileForm
  },
  MetaInfo() {
    return {
      link: [{ rel: 'canonical' }, { href: this.page_url }]
    }
  },
  data() {
    return {
      dates: [],
      room: null,
      images: null,
      virtual_tour: false,
      showVirtualTour: false,
      hasVideo: null,
      iframe: '',
      isLoading: false,
      fullPage: true,
      city_url: '',
      district_url: '',
      city_name: '',
      district_name: '',
      availability: {},
      dorm_name: '',
      dorm_url: '',
      dorm_title: '',
      keywords: '',
      page_url: '',
      branches: [],
      showMobileBottom: false,
      dormProperties: [],
      showDormForm: true,
      showShareButtons: false,
      url: '',
      mapurl: '',
      name: '',
      description: '',
      twitter_user: '',
      // emptyEmail: false,
      falseEmail2: false,
      emptyPassword: false,

      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      loginForm: {
        email: null,
        password: null
      },
      isFavorite: false,
      showModal: false,
      favorites: [],
      errors: [],
      universities: null,
      faculties: null,
      showSuccessMessage: false,
      isShowFormMobile: false,
      isNumberShow: false,
      isEmptyComment: false,
      dene1: [],
      messageForm: {
        dorm_id: null,
        name: '',
        email: '',
        university_id: '',
        faculty_id: '',
        phone: '',
        university_name: 'Üniversite Seç',
        faculty_name: 'Fakülte Seç'
      },
      emptyContent: {
        icon: 'icon-yorum-yok',
        title: 'Sonuç Bulunamadı!',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      properties: [
        {
          created_at: '2018-12-16 18:37:00',
          id: 1,
          properties: [],
          title: 'Bina Özellikleri',
          updated_at: '2018-12-16 18:37:00'
        },
        {
          created_at: '2018-12-16 18:37:00',
          id: 2,
          properties: [],
          title: 'Oda Özellikleri',
          updated_at: '2018-12-16 18:37:00'
        },
        {
          created_at: '2018-12-16 18:37:00',
          id: 3,
          properties: [],
          title: 'Hizmetler',
          updated_at: '2018-12-16 18:37:00'
        }
      ],
      center: {
        lat: 0,
        lng: 0
      },
      id: null,
      phone: null,
      phoneForMessage: null,
      member: '',
      infoWindowPos: null,
      infoWinOpen: true,
      currentMidx: null,
      showMap: null,
      mapOptions: {
        styles: [
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#d6e2e6'
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#cddbe0'
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#4a5aa3'
              }
            ]
          },
          {
            featureType: 'administrative.neighborhood',
            elementType: 'labels.text.fill',
            stylers: [
              {
                lightness: 25
              }
            ]
          },
          {
            featureType: 'administrative.land_parcel',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#edf0f8'
              }
            ]
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#d8dce2'
              }
            ]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#edf0f8'
              }
            ]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#7492a8'
              }
            ]
          },
          {
            featureType: 'landscape.natural.terrain',
            elementType: 'all',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#edf0f8'
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#588ca4'
              }
            ]
          },
          {
            featureType: 'poi', // places icons
            elementType: 'labels.icon',
            stylers: [
              {
                saturation: 100
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#cae7a8'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#bae6a1'
              }
            ]
          },
          {
            featureType: 'poi.sports_complex',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c6e8b3'
              }
            ]
          },
          {
            featureType: 'poi.sports_complex',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#bae6a1'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#41626b'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                saturation: -45
              },
              {
                lightness: 10
              },
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#f7fdff'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#beced4'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#dadee4'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#dadee4'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [
              {
                saturation: -70
              }
            ]
          },
          {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#588ca4'
              }
            ]
          },
          {
            featureType: 'transit.station',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#008cb5'
              }
            ]
          },
          {
            featureType: 'transit.station.airport',
            elementType: 'geometry.fill',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: -5
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#a6cbe3'
              }
            ]
          }
        ]
      },
      infoOptions: {
        maxWidth: 530,
        pixelOffset: {
          width: 150,
          height: -22
        }
      },
      marker: {
        position: {
          lat: 0,
          lng: 0
        }
      },
      isShare: false,
      isActive: false,
      formWidth: null,
      collapseContent: false,
      collapseContentHeight: null,
      stickyTab: false,
      currentPrice: null,
      currentRoom: null,
      fixedForm: false,
      formOffset: {
        top: 23 + 'px',
        left: 0
      },
      currentTab: 0,
      fixed: false,
      showForm: true,
      selected: null,
      swiperOption: {
        slidesPerView: 4,
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
            centeredSlides: false,
            slidesPerGroup: 2
          },
          640: {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroup: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      },
      tabs: [
        {
          id: 0,
          title: 'DÖNEMLİK',
          active: true
        },
        {
          id: 1,
          title: 'GÜNLÜK',
          active: false
        }
      ],
      answerName: '',
      comments: [],
      comments2: [
        {
          id: 0,
          name: 'Şahin Zaybak',
          date: '12 Kasım 2018',
          image: require('@/assets/img/comment-photo.png'),
          text:
            'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.',
          reply: [
            {
              id: 0,
              name: 'Mazlum Yıldırım',
              date: '12 Kasım 2018',
              image: require('@/assets/img/comment-photo.png'),
              text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel'
            }
          ]
        },
        {
          id: 1,
          name: 'Muhammed Erdem',
          date: '12 Kasım 2018',
          image: require('@/assets/img/comment-photo.png'),
          text:
            'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'
        }
      ],
      tabsMenu: [],
      detail: null
    }
  },
  methods: {
    async getRoomAvailability() {
      const formData = new FormData()
      formData.append('room_id', this.room.id)
      const res = await axios
        .post(`/site/room/availability`, formData)
        .catch(() => ({ data: [] }))
      this.availability = {}
      res.data.forEach(item => {
        this.availability[item.date] = item
      })
    },
    closeModalVirtualTour() {
      this.showVirtualTour = false
    },
    getFormData() {
      // repopulate faculty dropdown
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false

      if (window.localStorage.getItem('isLogin') === 'true') {
        this.messageForm.name =
          window.localStorage.getItem('first_name1') +
          ' ' +
          window.localStorage.getItem('last_name1')
        this.messageForm.email = window.localStorage.getItem('mail1')
        this.messageForm.university_name = window.localStorage.getItem(
          'university_name1'
        )
        this.messageForm.faculty_name = window.localStorage.getItem(
          'faculty_name1'
        )
        this.messageForm.phone = window.localStorage.getItem('phone1')
      }

      this.dormId = window.localStorage.getItem('dormid')
      this.url = window.localStorage.getItem('url')
    },
    saveForm() {
      window.localStorage.setItem('username', this.messageForm.name)
      window.localStorage.setItem('mail', this.messageForm.email)
      window.localStorage.setItem('phone1', this.messageForm.phone)
    },
    showShare() {
      this.isShare = !this.isShare
      this.showShareButtons = !this.showShareButtons
    },
    getFavorites() {
      let self = this
      axios
        .get(`/user/favorites`)
        .then(response => {
          self.favorites = response.data.favorites
          let isFavorite = self.favorites.find(function(dorm) {
            return dorm.id === window.localStorage.getItem('dormid')
          })
          if (isFavorite) {
            this.isFavorite = true
          }
        })
        .catch(e => {
          self.errors.push(e)
        })
      // console.log('1 favori: ' + self.favorites[0]. location)
    },
    setFavorite() {
      if (this.isLogin === '') {
        this.showModal = true
      } else {
        if (!this.isFavorite) {
          axios.post(`/site/dorm/favorite/${this.dormId}`, {})
        } else {
          axios.post(`/site/dorm/unfavorite/${this.dormId}`, {})
        }
        this.isFavorite = !this.isFavorite
      }
    },
    submitForm() {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      let email = this.messageForm.email
      const verifiedMail = this.$helpers.validateEmail(email)

      if (!this.messageForm.email) {
        this.emptyEmail = true
      } else if (this.messageForm.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.messageForm.name) {
        this.emptyName = true
      }
      if (!this.messageForm.phone) {
        this.emptyPhone = true
      }

      if (this.messageForm.phone && !this.messageForm.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (
        this.messageForm.phone &&
        !this.falsePhone &&
        this.messageForm.phone.length !== 11
      ) {
        this.shortPhone = true
      }

      if (!this.messageForm.university_id) {
        this.emptyUniversity = true
      }
      if (!this.messageForm.faculty_id) {
        this.emptyFaculty = true
      }

      if (
        !this.emptyName &&
        !this.emptyEmail &&
        !this.falseEmail &&
        verifiedMail &&
        !this.emptyPhone &&
        !this.falsePhone &&
        !this.shortPhone &&
        !this.emptyUniversity
      ) {
        let self = this
        const dormId = this.id
        axios
          .post(`/site/dorm/message/${dormId}`, {
            // data: this.messageForm
            name: this.messageForm.name,
            email: this.messageForm.email,
            phone: this.messageForm.phone,
            university_id: this.messageForm.university_id,
            faculty_id: this.messageForm.faculty_id,
            dorm_id: this.messageForm.dorm_id
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
            }
          })
        // }
      }
    },
    sendWhatsappMessage() {
      // this.isMessage = true
      window.open(
        'https://wa.me/' +
          this.phoneForMessage +
          '?text=Merhaba,%20Size%20yurtlarburada.com%20arac%C4%B1l%C4%B1%C4%9F%C4%B1yla%20ula%C5%9F%C4%B1yorum.%20Yurdunuz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum',
        '_blank'
      )
    },
    showNumber() {
      this.isNumberShow = true
    },
    toggleMobileForm() {
      this.getFormData()
      this.showSuccessMessage = false
      this.showErrorMessage = false
      this.isShowFormMobile = !this.isShowFormMobile
    },
    closeSuccessMessage() {
      this.showSuccessMessage = false
      this.isShowFormMobile = false
    },
    getUniversities() {
      let self = this
      axios
        .get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectUniversity(opt) {
      this.university_id = opt.id
      this.messageForm.university_id = opt.id
      window.localStorage.setItem('university_name', opt.name)
      window.localStorage.setItem('university_id', opt.id)
      let self = this
      axios
        .get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
      // this.saveForm()
    },
    selectFaculty(opt) {
      this.messageForm.faculty_id = opt.id
      window.localStorage.setItem('faculty_name', opt.name)
      window.localStorage.setItem('faculty_id', opt.id)
      this.saveForm()
    },
    register() {
      this.$router.push('/kayit-ol')
    },
    login() {
      /*       if (this.validateForm()) {
                  console.log('formValidated');
                  //submit form to backend
              }

        this.validate()
        */

      this.emptyEmail2 = false
      this.falseEmail2 = false
      this.emptyPassword = false

      const verifiedMail = this.$helpers.validateEmail(this.loginForm.email)
      if (!this.loginForm.password) {
        this.emptyPassword = true
      }
      if (!this.loginForm.email) {
        this.emptyEmail2 = true
      } else if (!this.emptyEmail2 && !verifiedMail) {
        this.falseEmail2 = true
      }

      if (verifiedMail && this.loginForm.password) {
        var self = this
        /*       if(!this.valid) {
          // this.email = 'Mail giriniz'
          this.$refs.input1.value = 'Mail giriniz'
        } */
        // if(this.valid) {
        axios
          .post(`/user/login`, {
            email: this.loginForm.email,
            password: this.loginForm.password
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              // self.showSuccessMessage = true
              // self.commit(SET_USER_INFO, response.data.user)
              self.$store.commit(SET_USER_INFO, response.data.user)
              const data = { updateLogin: true, isLogin: 'true' }
              self.$store.commit(SET_USER_INFO, data)
              self.$router.push(this.$route.params.slug + '-y-' + this.dormId)
              this.closeModal()
              window.localStorage.setItem(
                'first_name',
                response.data.user.first_name
              )
              window.localStorage.setItem(
                'last_name',
                response.data.user.last_name
              )
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem(
                'username',
                response.data.user.first_name +
                  ' ' +
                  response.data.user.last_name
              )
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem(
                'university_id',
                response.data.user.university_id
              )
              window.localStorage.setItem(
                'faculty_id',
                response.data.user.faculty_id
              )

              self.setUniversityName(
                response.data.user.university_id,
                response.data.user.faculty_id
              )

              this.messageForm.name = window.localStorage.getItem('username')
              this.messageForm.email = window.localStorage.getItem('mail')
              this.messageForm.university_id = window.localStorage.getItem(
                'university_id'
              )
              this.messageForm.faculty_id = window.localStorage.getItem(
                'faculty_id'
              )

              this.isFavorite = true
              // document.cookie = "username=response.data.user.first_name; expires=Thu, 18 Dec 2019 12:00:00 UTC";
            } else {
              self.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
              // console.log('hata: ' + error.response)
            }
          })
      }
    },
    /*     limitStr (string, limit) {
                    let str = string;

                    if (typeof str === 'string' && str.length > limit) {
                      str = str.slice(0, limit) + '...'
                    }
                    return str
                  }, */
    closeModal() {
      this.showModal = false
    },
    closeModaSuccess() {
      this.showSuccessMessage = false
    },
    updateTabs() {
      if (
        this.showMap &&
        this.dormProperties.length > 0 &&
        this.detail.dorm.virtual_tour &&
        !this.$helpers.mobileCheck()
      ) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Özellikler',
            link: '#ozellikler',
            isActive: true
          },
          {
            id: 2,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: false
          },
          {
            id: 3,
            title: 'Harita',
            link: '#Harita',
            isActive: false
          },
          {
            id: 4,
            title: 'Sanal Tur',
            link: '#Sanal',
            isActive: false
          }
        ]
      } else if (this.showMap && this.dormProperties.length > 0) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Özellikler',
            link: '#ozellikler',
            isActive: true
          },
          {
            id: 2,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: false
          },
          {
            id: 3,
            title: 'Harita',
            link: '#Harita',
            isActive: false
          }
        ]
      } else if (
        this.showMap &&
        this.dormProperties.length === 0 &&
        this.detail.dorm.virtual_tour
      ) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: true
          },
          {
            id: 2,
            title: 'Harita',
            link: '#harita',
            isActive: false
          },
          {
            id: 3,
            title: 'Sanal Tur',
            link: '#Sanal',
            isActive: false
          }
        ]
      } else if (this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: true
          },
          {
            id: 2,
            title: 'Harita',
            link: '#harita',
            isActive: false
          }
        ]
      } else if (
        !this.showMap &&
        this.dormProperties.length === 0 &&
        this.detail.dorm.virtual_tour
      ) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: true
          },
          {
            id: 2,
            title: 'Sanal Tur',
            link: '#Sanal',
            isActive: false
          }
        ]
      } else if (!this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: true
          }
        ]
      } else {
        this.tabsMenu = [
          {
            id: 1,
            title: 'Özellikler',
            link: '#ozellikler',
            isActive: true
          },
          {
            id: 2,
            title: 'Yorumlar',
            link: '#yorumlar',
            isActive: false
          }
        ]
      }
    },
    sendComment: function() {
      if (this.isLogin === '') {
        this.showModal = true
        // var modal = this.$refs.myModal
        // modal.style.display = "block"
      } else {
        if (!this.$refs.messageField.value) {
          this.isEmptyComment = true
        } else {
          this.isEmptyComment = false
          // console.log(this.$refs.messageField.value)
          const mytoken = window.localStorage.getItem('access_token')
          axios
            .post(`/site/dorm/comment/${this.id}`, {
              token: mytoken,
              comment: this.$refs.messageField.value
            })
            .then(response => {
              this.$refs.messageField.value = ''

              let self = this
              let dormID = this.$route.params.slug
              dormID = dormID.split('-').reverse()[0]
              const url = self.$attrs.redirect
                ? `/site/dorm/detail/${dormID}`
                : `/site/dorm/detail/${this.$route.params.id}`
              axios
                .get(url)
                .then(response => {
                  self.comments = response.data.dorm.comments.reverse()
                  self.comments.forEach(item => {
                    const str = item.created_at.split(':')
                    item.created_at = str[0] + ':' + str[1]
                  })
                })
                .catch(e => {
                  self.errors.push(e)
                })
            })

          //      this.$refs.messageField.value = ''
        }
      }
    },
    tabSelect(index, title) {
      if (title === 'Sanal Tur') {
        this.showVirtualTour = true
      } else {
        if (!this.showMap && this.dormProperties.length === 0) {
          this.tabsMenu[0].isActive = true
        } else {
          this.tabsMenu[1].isActive = false
        }
        if (this.dormProperties.length > 0) {
          this.tabsMenu[0].isActive = false
        }
        // this.tabsMenu[0].isActive = false

        if (this.showMap && this.dormProperties.length > 0) {
          this.tabsMenu[2].isActive = false
        } else if (this.showMap && this.dormProperties.length === 0) {
          this.tabsMenu[1].isActive = false
        }
        this.tabsMenu[index].isActive = true

        if (index === 0) {
          window.scrollTo({
            top: this.$refs.paneOne.offsetTop - 90,
            left: 0,
            behavior: 'smooth'
          })
        } else if (this.dormProperties.length === 0 && index === 1) {
          // özellikler yok harita var
          this.tabsMenu[1].isActive = true
          window.scrollTo({
            // top: this.$refs.paneTwo.offsetTop - 80,
            top: this.$refs.paneThree.offsetTop - 70,
            left: 0,
            behavior: 'smooth'
          })
        } else if (this.dormProperties.length > 0 && index === 1) {
          // if(self.comments.length > 0) yoruma göre offset top depğişebilir
          window.scrollTo({
            top: this.$refs.paneTwo.offsetTop - 80,
            // top: this.$refs.paneThree.offsetTop - 70,
            left: 0,
            behavior: 'smooth'
          })
        } else if (index === 2) {
          window.scrollTo({
            top: this.$refs.paneThree.offsetTop - 70,
            left: 0,
            behavior: 'smooth'
          })
        }
      }
    },
    toggleInfoWindow() {
      this.infoWinOpen = !this.infoWinOpen
      // console.log('clicked on marker')
    },
    toggleContentText() {
      this.collapseContent = !this.collapseContent
      this.collapseContentHeight =
        this.$refs.dormContentText.offsetHeight + 'px'
    },
    changePrice(item, price) {
      this.currentRoom = item
      this.currentPrice = price
    },
    tabShow(id) {
      this.tabs.forEach(item => {
        item.active = false
      })
      this.tabs[id].active = true
    },
    answer(reply) {
      this.answerName = '@' + reply + ' '
    },
    setOffsets() {
      this.formWidth = this.$refs.dormRight.offsetWidth
    },
    handleScroll() {
      if (window.scrollY > 110 && window.scrollY < 2200) {
        this.showMobileBottom = true
      } else {
        this.showMobileBottom = false
      }
      let windowY = window.scrollY
      const paneOne = this.$refs.paneOne
      const paneTwo = this.$refs.paneTwo
      const paneThree = this.$refs.paneThree
      const dormSlider = this.$refs.dormSlider

      const dormForm = this.$refs.dormForm
      const contentOffsetTop = this.$refs.dormContent.offsetTop
      const contentOffsetLeft =
        this.$refs.dormContent.offsetLeft + this.$refs.dormRight.offsetLeft

      // if (windowY + 350 >= contentOffsetTop && windowY + 350 <= (dormSlider.offsetTop - dormForm.$el.offsetHeight)) {
      if (
        windowY >= contentOffsetTop &&
        windowY <= dormSlider.offsetTop - dormForm.$el.offsetHeight
      ) {
        this.fixedForm = true
        this.formOffset.left = contentOffsetLeft + 'px'
        this.formOffset.top = 10 + 'px'
        this.formOffset.position = 'fixed'
      } else if (windowY > dormSlider.offsetTop - dormForm.$el.offsetHeight) {
        // let w = window.scrollY
        // this.fixedForm = true
        this.formOffset.left = 0
        // this.formOffset.top = 23 + 'px'
        // this.formOffset.position = 'absolute'

        this.formOffset.top =
          dormSlider.offsetTop - dormForm.$el.offsetHeight - 125 + 'px'
        this.formOffset.position = 'absolute'
      } else {
        this.fixedForm = true
        this.formOffset.left = 0
        this.formOffset.top = 23 + 'px'
        this.formOffset.position = 'absolute'
      }

      // sections
      if (
        windowY >= paneOne.offsetTop - 80 &&
        windowY < paneTwo.offsetTop - 80
      ) {
        this.currentTab = 0
        this.stickyTab = true
        if (this.tabsMenu[0]) {
          this.tabsMenu[0].isActive = true
        }
        if (this.tabsMenu[0]) {
          this.tabsMenu[1].isActive = false
        }

        if (this.showMap) {
          this.tabsMenu[2].isActive = false
        }
      } else if (
        this.showMap &&
        windowY >= paneTwo.offsetTop - 120 &&
        windowY < paneThree.offsetTop - 80
      ) {
        this.currentTab = 1
        this.stickyTab = true
        if (this.dormProperties.length > 0) {
          this.tabsMenu[0].isActive = false
          this.tabsMenu[1].isActive = true
          this.tabsMenu[2].isActive = false
        } else {
          this.tabsMenu[0].isActive = true
          this.tabsMenu[1].isActive = false
        }
      } else if (
        windowY >= paneThree.offsetTop - 75 &&
        windowY < dormSlider.offsetTop
      ) {
        this.currentTab = 2
        this.stickyTab = true
        if (this.tabsMenu[0]) {
          this.tabsMenu[0].isActive = false
        }

        if (this.dormProperties.length === 0 && this.showMap) {
          this.tabsMenu[1].isActive = true
        } else if (this.tabsMenu[1]) {
          this.tabsMenu[1].isActive = false
        }
        if (this.showMap && this.tabsMenu[2]) {
          this.tabsMenu[2].isActive = true
        }
      } else if (windowY >= dormSlider.offsetTop) {
        this.stickyTab = false
      } else {
        this.stickyTab = false
      }

      /*                     if (this.showMap) {
                          if (windowY >= (paneTwo.offsetTop - dormForm.$el.offsetHeight) && windowY < paneThree.offsetTop - (paneTwo.offsetHeight - 200)) {
                              console.log('burdamı1')
                              this.formOffset.left = 0
                              this.formOffset.top = (paneTwo.offsetTop - dormForm.$el.offsetHeight - 71) + 'px'
                              // 23 + 'px'
                              this.formOffset.position = 'absolute'
                          }
                      } */
    },
    getDormDetails() {
      let self = this
      this.isLoading = true
      let dormID = this.$route.params.dorm_id
      const url = self.$attrs.redirect
        ? `/site/dorm/detail/old/${dormID}`
        : `/site/dorm/detail/${this.$route.params.dorm_id}`
      axios
        .get(url)
        .then(response => {
          this.isLoading = false
          let roomExist = false
          response.data.dorm.rooms.forEach(room => {
            if (+room.id === +self.$route.params.room_id) {
              roomExist = true
              self.room = room
            }
          })
          if (!roomExist) {
            self.$router.push({
              name: 'DormDetail',
              params: {
                dorm_id: self.$route.params.dorm_id,
                slug: self.$route.params.slug
              }
            })
            return
          }
          self.getRoomAvailability()
          self.dorm_url = `/${self.$route.params.slug}-y-${self.$route.params.dorm_id}`
          self.dorm_title = response.data.dorm.name
          self.id = response.data.dorm.id
          self.phone = response.data.dorm.mobile_phone
          self.phoneForMessage = response.data.dorm.phone_for_message
          self.member = response.data.dorm.member
          self.virtual_tour = response.data.dorm.virtual_tour
          self.detail = response.data
          self.description = response.data.dorm.description
          self.keywords = response.data.dorm.keywords
          self.dorm_url =
            response.data.dorm.slug + '-y-' + response.data.dorm.id
          self.city_url =
            '/' + response.data.dorm.city.slug + '-ozel-ogrenci-yurtlari/'
          self.district_url =
            '/' +
            response.data.dorm.city.slug +
            '-' +
            response.data.dorm.district.slug +
            '-ilcesi-ogrenci-yurtlari/'
          self.dorm_name = response.data.dorm.name
          self.city_name = response.data.dorm.city.name
          self.district_name = response.data.dorm.district.name
          self.page_url =
            window.location.origin +
            '/' +
            response.data.dorm.slug +
            '-y-' +
            response.data.dorm.id
          // 669 460 yapıldı du
          // let l = self.detail.dorm.content.length
          self.mapurl =
            'https://www.google.com/maps/dir//' +
            response.data.dorm.lat +
            ',' +
            response.data.dorm.lng // 40.768319,30.416167'/
          // self.mapurl = 'https://maps.googleapis.com/maps/api/place/nearbysearch/json?type=university&location='+ response.data.dorm.lat + ',' + response.data.dorm.lng + '&radius=500&key=AIzaSyDYd2ezpHJldbKmnSC5WAkD4V-Uv3NAuYk'
          self.name = self.room.title
          response.data.branches.forEach(item => {
            if (item.id !== self.id) {
              self.branches.push(item)
            }
          })

          //
          // video content e gömülmüşse oradan al
          // if(response.data.dorm.content.includes('iframe')) {
          if (response.data.dorm.video) {
            this.hasVideo = true

            /*
             let content1 = response.data.dorm.content.split('</iframe>')
            self.detail.dorm.content = content1[1].replace('<p><br></p><p><br></p>', '')
            self.iframe = content1[0]
            let src1 = self.iframe.split('src="')
            let src = src1[1].replace('">')

            let videoId = src.split('embed/')
            let videoId2 = videoId[1].split('?')
            */

            let src = response.data.dorm.video.url.replace('watch?v=', 'embed/')
            window.localStorage.setItem('src', src)

            let videoUrl = response.data.dorm.video.url.split('=')
            self.images = [
              {
                id: 1,
                filename:
                  'https://img.youtube.com/vi/' +
                  videoUrl[1] +
                  '/hqdefault.jpg', // a4XsqC_K4lg
                sort: 0,
                created_at: '',
                updated_at: ''
              }
            ]

            if (self.room.images && self.room.images.length > 0) {
              self.images.push(...self.room.images)
            }

            response.data.dorm.images.forEach(image => {
              self.images.push(image)
            })
          } else {
            console.log('self room', self.room)
            window.localStorage.setItem('src', null)
            self.images = []
            if (self.room.images && self.room.images.length > 0) {
              self.images.push(...self.room.images)
            }
            self.images = [...self.images, ...response.data.dorm.images]
          }

          // window.localStorage.setItem('virtual_tour', response.data.dorm.virtual_tour)
          // self.detail.dorm.images[0].src = src
          // son resme src ekle

          /*           self.detail.dorm.images[self.detail.dorm.images.length - 1].src = src
            let content = content1[1]
            let dene = content.length */

          self.comments = response.data.dorm.comments.reverse()
          self.comments.forEach(item => {
            const str = item.created_at.split(':')
            item.created_at = str[0] + ':' + str[1]
            const str2 = item.created_at.split(' ')
            const str3 = str2[0].split('-')
            item.created_at =
              str3[2] + '-' + str3[1] + '-' + str3[0] + ' ' + str2[1]
            /*             if(item.comment.includes('@')) {
                                                    self.dene1.push(item)
                                                    // self.comments.remove(item)
                                                  } */
          })
          self.dormProperties = response.data.dorm.properties
          response.data.dorm.properties.forEach((item, index) => {
            if (item.category_id === 1) {
              self.properties[0].properties.push(
                response.data.dorm.properties[index]
              )
            }
            if (item.category_id === 2) {
              self.properties[1].properties.push(
                response.data.dorm.properties[index]
              )
            }
            if (item.category_id === 3) {
              self.properties[2].properties.push(
                response.data.dorm.properties[index]
              )
            }
          })
          // self.detail.dorm.content = self.limitStr(self.detail.dorm.content, 700)
          let lng = parseFloat(response.data.dorm.lng)
          let lat = parseFloat(response.data.dorm.lat)
          self.center.lng = lng
          self.showMap = lng !== 0 && lat !== 0
          self.updateTabs()
          self.center.lat = lat
          self.marker.position.lng = lng
          self.marker.position.lat = lat
          let myInterval = setInterval(() => {
            if (this.google) {
              clearInterval(myInterval)
              self.$nextTick(() => {
                self.$refs.mapRef.$mapPromise.then(map => {
                  let request = {
                    query: 'university',
                    location: new google.maps.LatLng(
                      self.center.lat,
                      self.center.lng
                    ),
                    radius: '5000'
                  }
                  let request2 = {
                    query: 'meal_delivery',
                    location: new google.maps.LatLng(
                      self.center.lat,
                      self.center.lng
                    ),
                    radius: '5000'
                  }
                  let request3 = {
                    query: 'atm',
                    location: new google.maps.LatLng(
                      self.center.lat,
                      self.center.lng
                    ),
                    radius: '5000'
                  }
                  let service = new google.maps.places.PlacesService(map)
                  service.textSearch(request, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                      self.createMarker(results)
                    }
                  })
                  service.textSearch(request2, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                      self.createMarker2(results)
                    }
                  })
                  service.textSearch(request3, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                      self.createMarker3(results)
                    }
                  })
                })
              })
            }
          })
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    createMarker(mrk) {
      mrk.forEach(m => {
        var marker = new google.maps.Marker({
          position: m.geometry.location,
          map: this.$refs.mapRef.$mapObject,
          title: m.name
        })
        marker.addListener('click', this.toggleInfoWindow)
      })
    },
    createMarker2(mrk) {
      mrk.forEach(m => {
        var marker = new google.maps.Marker({
          position: m.geometry.location,
          map: this.$refs.mapRef.$mapObject,
          title: m.name,
          icon: {
            url:
              'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
          }
        })
        marker.addListener('click', this.toggleInfoWindow)
      })
    },
    createMarker3(mrk) {
      mrk.forEach(m => {
        // eslint-disable-next-line no-new
        new google.maps.Marker({
          position: m.geometry.location,
          map: this.$refs.mapRef.$mapObject,
          title: m.name,
          icon: {
            url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
          }
        })
      })
    },
    string_to_slug(str) {
      str = str.replace('Yurtları', 'Yurtlari')
      str = str.replace('Öğrenci', 'Ogrenci')
      str = str.replace('Kız ', 'Kiz ')
      str = str.replace('Beşiktaş ', 'besiktas')
      str = str.replace('ş', 's')
      str = str.replace('Ş', 'S')
      str = str.replace('ı', 'i')
      str = str.replace('I', 'i')
      str = str.replace('Ğ', 'G')
      str = str.replace('ğ', 'g')
      str = str.replace('Ü', 'U')
      str = str.replace('ü', 'u')
      str = str.replace('ö', 'o')
      str = str.replace('Ö', 'O')

      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
    checkDistrict() {
      if (!this.$route.params.district) {
        if (this.$route.fullPath.includes('ilcesi')) {
          this.district = 'empty' // this.$route.params.district
        } else {
          this.district = null
        }
      } else {
        this.district = this.$route.params.district
      }
    }
  },
  created() {
    if (this.$route.fullPath.includes('-s-')) {
      let route = {
        name: 'BranchMain',
        params: { dorm: this.$route.params.slug }
      }
      this.$router.push(route)
    }
    window.addEventListener('scroll', this.handleScroll)
    this.dormId = window.localStorage.getItem('dormid')
    this.url = window.localStorage.getItem('url')
    this.getUniversities()
    this.checkDistrict()
    //    this.getFormData()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.setOffsets()
    this.getDormDetails()
    //  this.getFormData()
    this.twitter_user =
      window.localStorage.getItem('first_name') +
      window.localStorage.getItem('last_name') // this.first_user + this.last_user
  },
  computed: {
    ...mapGetters(['isLogin']),
    getGender() {
      if (this.detail && this.detail.dorm.dorm_type_id === 1) {
        return 'erkek'
      } else {
        return 'kiz'
        // return this.getName.charAt(0).toUpperCase() + name.slice(1) + '-kiz-' + 'ogrenci-yurtlari'
      }
    },
    getDormName() {
      if (this.detail) {
        return this.detail.dorm.name
      } else {
        return ''
      }
    },
    getDistrict() {
      if (this.detail) {
        return this.detail.dorm.district
      } else {
        return {}
      }
    },
    getCity() {
      if (this.detail) {
        return this.detail.dorm.city
      } else {
        return {}
      }
    },
    getCityName() {
      if (this.detail) {
        return this.detail.dorm.city.name
      } else {
        return ''
      }
    },
    getDormType() {
      if (this.detail) {
        if (this.detail.dorm.dorm_type_id === 1) {
          return 'Erkek'
        } else {
          return 'Kız'
        }
      } else {
        return ''
      }
    },
    getDormSlug() {
      if (this.detail) {
        return this.string_to_slug(this.detail.dorm.name)
      } else {
        return ''
      }
    }
  },
  watch: {
    $route() {
      this.getDormDetails()
      this.checkDistrict()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/components/dorm-detail';
@import '@/assets/scss/components/sticky-nav';
.sticky-nav__space {
  height: 83px;
}

.mycolor2 {
  color: red;
}

.mytitleDetail {
  font-size: 15px;
  color: gray;
}

.mycomment {
  font-weight: 400;
  font-size: 16px;
}

.mysuccessMessage {
  font-size: 18px;
  text-align: center;
}

.mycenter {
  display: table;
  margin: 0 auto;
}

.mysize {
  font-size: 16px;
}

.mycolorBlue {
  color: #4b5ba4;
  font-weight: bold;
}
.mycolor2a {
  color: #17d9ae;
  font-weight: bold;
}

.mysharebuttons {
  cursor: pointer;
  margin-top: 18px;
}

.mysharebuttons > .icon-font {
  font-size: 18px;
  color: #9198b2;
  width: 100%;
}

.mysharebuttons .icon-font > span {
  width: 33%;
  display: block;
  text-align: center;
  border-right: 1px solid #ddd;
  &:hover {
    .mybutton {
      color: #eb6081;
    }
  }
}

.mysharebuttons .icon-font > span:last-child {
  border-right: none;
}

.mycolorshare {
  color: #4b5ba4;
}

.myfontstyle {
  font-style: normal !important;
}

.myborder {
  padding-top: 0px 0;
  padding-top: 0px 0;
  border-bottom: 1px solid rgba(172, 179, 201, 0.45);
  //border-top: 1px solid rgba(172, 179, 201, 0.45);
  margin-top: 0px;
  margin-bottom: 0px;

  border-left: none;
}
</style>
